module.exports = __webpack_public_path__ + "static/media/image_60.2f380fdf.png";